<template>
  <div class="not-found-container">
    <h1>404</h1>
    <p>Sorry, the page you are looking for does not exist.</p>
    <router-link to="/">Go back home</router-link>
  </div>
</template>

<script setup>
import { useHead } from '@vueuse/head';

useHead({
  title: 'Reeflendar.com - Page Not Found',
  meta: [
    { name: 'description', content: '404 Not Found - Reeflendar.' },
    { name: 'keywords', content: '404, not found, aquarium' },
  ],
});
</script>

<style scoped>
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}
h1 {
  font-size: 6rem;
  margin-bottom: 1rem;
}
p {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
}
</style>
